import React, { useState } from "react"
import { Card, CardBody, Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import User from "../User"
import UserForm from "./UserForm"
import RolesIndex from "../Roles"
import EditRole from "../Roles/edit"
import "../Tenancy/tenancy.css"

/**
 * User Management — User Access + Role Access as tabs (StaffFlow parity).
 * Each tab embeds the existing list page (User / Roles) in `embedded` mode so it
 * renders without its own page wrapper/breadcrumb.
 */
const UserManagement = () => {
  document.title = "User Management | Everrise"
  const [tab, setTab] = useState("users")
  // Role Access can show the list or the add/edit form in-place (keeps the tabs).
  const [roleView, setRoleView] = useState({ mode: "list", id: null })
  const [rolesRefresh, setRolesRefresh] = useState(0)
  const closeRoleEdit = saved => {
    setRoleView({ mode: "list", id: null })
    if (saved) setRolesRefresh(n => n + 1)
  }
  // User Access can show the list or the add/edit form in-place (keeps the tabs).
  const [userView, setUserView] = useState({ mode: "list", user: null })
  const [usersRefresh, setUsersRefresh] = useState(0)
  const closeUserEdit = saved => {
    setUserView({ mode: "list", user: null })
    if (saved) setUsersRefresh(n => n + 1)
  }

  return (
    <div className="page-content tnt-scope">
      <div className="container-fluid">
        <Breadcrumbs
          title="Administration"
          breadcrumbObject={[
            { title: "Administration", link: "#" },
            { title: "User Management", link: "#" },
          ]}
        />
        <Card className="tnt-page-card me-2 px-2 pb-2 main-dashboard-bg">
          <CardBody className="app-tab-shell um-tab-shell">
            <Nav tabs className="mb-3">
              <NavItem>
                <NavLink className={tab === "users" ? "active" : ""} style={{ cursor: "pointer" }} onClick={() => setTab("users")}>
                  User Access
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink className={tab === "roles" ? "active" : ""} style={{ cursor: "pointer" }} onClick={() => setTab("roles")}>
                  Role Access
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={tab}>
              <TabPane tabId="users">
                {tab === "users" &&
                  (userView.mode === "list" ? (
                    <User
                      key={usersRefresh}
                      embedded
                      onAddUser={() => setUserView({ mode: "form", user: null })}
                      onEditUser={u => setUserView({ mode: "form", user: u })}
                    />
                  ) : (
                    <UserForm editUser={userView.user} onDone={closeUserEdit} />
                  ))}
              </TabPane>
              <TabPane tabId="roles">
                {tab === "roles" &&
                  (roleView.mode === "list" ? (
                    <RolesIndex
                      key={rolesRefresh}
                      embedded
                      onAddRole={() => setRoleView({ mode: "add", id: null })}
                      onEditRole={id => setRoleView({ mode: "edit", id })}
                    />
                  ) : (
                    <EditRole
                      embedded
                      roleId={roleView.id}
                      onClose={closeRoleEdit}
                    />
                  ))}
              </TabPane>
            </TabContent>
          </CardBody>
        </Card>
      </div>
    </div>
  )
}

export default UserManagement
